import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StringHelper } from '@core/helpers/string.helper';
import { Estimate } from '@interfaces/Estimate';
import { ImportProjectDto } from '@interfaces/ImportProjectDTO';
import { BaseService } from '@shared/services/base.service';
import { LoadingService } from '@shared/services/loading.service';
import { lastValueFrom, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataManagementService extends BaseService {
  public constructor(private http: HttpClient, private loadingService: LoadingService) {
    super();
  }
  public async exportToGpSifia(estimate: Estimate) {
    await this.loadingService.run(() => {
      return lastValueFrom(
        this.http.post<string>(
          `${this.baseUrl}/EAP/DeployEstimate/${estimate.codeRef}/${estimate.revision}/00`,
          estimate
        )
      );
    });
    this.refreshEstimates();
  }
  public async refreshEstimates() {
    const estimates = await lastValueFrom(this.http.get<Estimate[]>(`${this.baseUrl}/web/estimateExport/estimate`));
    estimates.forEach(e => {
      if (!StringHelper.HasValue(e.codeRef)) {
        e.codeRef = undefined; // patches an issue where CodeRef is set to ' '
      }
    });
    this.getEstimates$.next(estimates);
    return estimates;
  }
  private getProjectCodesNotInEstimate$ = new Subject<ImportProjectDto[]>();
  public getProjectCodesNotInEstimate(refresh = true) {
    return this.getProjectCodesNotInEstimate$.asObservable();
  }
  private getEstimates$ = new Subject<Estimate[]>();
  public getEstimates(refresh = true) {
    if (refresh) {
      this.refreshEstimates();
    }

    return this.getEstimates$.asObservable();
  }
}
